import { useState } from 'react';

import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import ErrorModal from 'app/components/ErrorModal';
import AccountBillingForm from './AccountBillingForm';
import MessageModal from 'app/components/MessageModal';

const AccountBillingPanel = props => {
  const {
    accountBilling,
    action,
    onClose,
    onDelete
  } = props;

  // if we're creating a customer then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  let cards = [
    {
      label: 'Delete Account Billing',
      message: 'Removes the Account Billing record.',
      actions: [
        { label: 'Delete Account Billing', callback: onDelete }
      ]
    }
  ]

  return (
    <div>
      <ResourceModalPanel cards={cards} />
    </div>
  )
}

const AccountBillingModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    accountBilling
  } = props;

  const [error, setError] = useState(null);

  let title, subTitle = null;

  if (accountBilling) {
    title = accountBilling.billing_name;
  } else {
    title = 'New Account Billing';
  }

  const action = accountBilling ? 'update' : 'create';

  const onSubmit = params => {
    if (!params.billing_id) {
      setError('Please select a billing entity');
      return;
    }
    if (!params.account_id) {
      setError('Please select an account');
      return;
    }
    onFormSubmit(action, params).catch(ex => {
      setError(ex.error);
    })
  };

  const onDelete = () => onDestroy(accountBilling.id);

  return (
    <div>
      <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
        <AccountBillingPanel {...{ accountBilling, action, onClose, onDelete }} />
        <AccountBillingForm {...{ accountBilling, action, onClose, onSubmit }} />
      </ResourceModal>
      <MessageModal
        isOpen={error !== null}
        onClose={() => setError(null)}
        title='Account Billing'
        message={error}
      />
    </div>
  );

}

export default AccountBillingModal
